import { createElement } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { MapPin, Phone, Mail, Building2, IdCard, User, FileText, CalendarDays, Clock, ScrollText, Truck, Package, ShieldCheck, Headset, CreditCard, ListChecks, UserCheck } from "lucide-react";

// Lucide ikonlarını PDF'e gömmek için PNG'ye (canvas) çevirir — renk/kalınlık bazında önbellekli.
const ICONS = { pin: MapPin, phone: Phone, mail: Mail, building: Building2, id: IdCard, user: User, file: FileText, calendar: CalendarDays, clock: Clock, scroll: ScrollText, truck: Truck, box: Package, shield: ShieldCheck, headset: Headset, card: CreditCard, list: ListChecks, staff: UserCheck };
const cache = new Map();

function svgToPng(svg, size) {
  return new Promise((resolve, reject) => {
    const im = new Image();
    im.onload = () => {
      const c = document.createElement("canvas");
      c.width = size; c.height = size;
      c.getContext("2d").drawImage(im, 0, 0, size, size);
      resolve(c.toDataURL("image/png"));
    };
    im.onerror = reject;
    im.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  });
}

export async function loadIcons(color = "#0F2745", strokeWidth = 1.7, size = 256) {
  const key = `${color}|${strokeWidth}|${size}`;
  if (cache.has(key)) return cache.get(key);
  const out = {};
  await Promise.all(Object.entries(ICONS).map(async ([k, Icon]) => {
    try { out[k] = await svgToPng(renderToStaticMarkup(createElement(Icon, { color, size, strokeWidth })), size); }
    catch { out[k] = null; }
  }));
  cache.set(key, out);
  return out;
}
